import React from 'react';
import { CheckIcon, SparklesIcon } from 'lucide-react';
const PricingSection = () => {
  return <section id="pricing" className="py-4 opacity-5 pointer-events-none h-16 overflow-hidden" aria-hidden="true" data-id="element-223">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-224">
        <div className="text-center" data-id="element-225">
          <h2 className="text-sm font-bold text-[#E87B5C]" data-id="element-226">
            Premium features coming soon
          </h2>
        </div>
        {/* Hidden pricing content preserved for future use */}
        <div className="hidden" data-id="element-227">
          {/* Two-column pricing cards */}
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-228">
            {/* Free Plan */}
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-gray-200" data-id="element-229">
              <div className="p-8 md:p-10" data-id="element-230">
                {/* Header with price */}
                <div className="text-center mb-8" data-id="element-231">
                  <div className="inline-flex items-center justify-center mb-3" data-id="element-232">
                    <h3 className="text-2xl font-bold text-gray-800" data-id="element-233">
                      Free Plan
                    </h3>
                  </div>
                  <p className="text-4xl font-bold text-gray-900" data-id="element-234">
                    $0{' '}
                    <span className="text-base font-normal text-gray-500" data-id="element-235">
                      forever
                    </span>
                  </p>
                </div>
                {/* CTA Button */}
                <div className="mb-10" data-id="element-236">
                  <a href="#" className="block w-full py-4 px-6 bg-gray-100 text-gray-800 text-center text-lg font-medium rounded-full hover:bg-gray-200 transition-all" data-id="element-237">
                    Get Started
                  </a>
                </div>
                {/* Divider */}
                <div className="relative my-8" data-id="element-238">
                  <div className="absolute inset-0 flex items-center" data-id="element-239">
                    <div className="w-full border-t border-gray-200" data-id="element-240"></div>
                  </div>
                  <div className="relative flex justify-center" data-id="element-241">
                    <span className="bg-white px-4 text-sm text-gray-500" data-id="element-242">
                      Free Features
                    </span>
                  </div>
                </div>
                {/* Features List */}
                <div className="space-y-4" data-id="element-243">
                  <div className="flex items-start" data-id="element-244">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-245">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-246" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-247">
                      Basic reframing suggestions
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-248">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-249">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-250" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-251">
                      Simple tone detection
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-252">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-253">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-254" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-255">
                      5 reframes per day
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-256">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-257">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-258" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-259">
                      Community support
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Premium Plan */}
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-[#E87B5C]/20 relative" data-id="element-260">
              {/* Popular badge */}
              <div className="absolute top-0 right-0 bg-gradient-to-r from-[#E87B5C] to-[#FFD700] text-white text-xs font-bold px-4 py-1 rounded-bl-lg" data-id="element-261">
                MOST POPULAR
              </div>
              <div className="p-8 md:p-10" data-id="element-262">
                {/* Header with price */}
                <div className="text-center mb-8" data-id="element-263">
                  <div className="inline-flex items-center justify-center mb-3" data-id="element-264">
                    <SparklesIcon className="h-6 w-6 text-[#FFD700] mr-2" data-id="element-265" />
                    <h3 className="text-2xl font-bold text-[#E87B5C]" data-id="element-266">
                      Premium Plan
                    </h3>
                  </div>
                  <p className="text-4xl font-bold text-gray-900" data-id="element-267">
                    $9.99{' '}
                    <span className="text-base font-normal text-gray-500" data-id="element-268">
                      per month
                    </span>
                  </p>
                </div>
                {/* CTA Button */}
                <div className="mb-10" data-id="element-269">
                  <a href="#" className="block w-full py-4 px-6 bg-gradient-to-r from-[#E87B5C] to-[#E87B5C]/90 text-white text-center text-lg font-medium rounded-full hover:shadow-md transition-all transform hover:-translate-y-0.5" data-id="element-270">
                    Upgrade Now
                  </a>
                </div>
                {/* Divider */}
                <div className="relative my-8" data-id="element-271">
                  <div className="absolute inset-0 flex items-center" data-id="element-272">
                    <div className="w-full border-t border-gray-200" data-id="element-273"></div>
                  </div>
                  <div className="relative flex justify-center" data-id="element-274">
                    <span className="bg-white px-4 text-sm text-gray-500" data-id="element-275">
                      Premium Features
                    </span>
                  </div>
                </div>
                {/* Features List */}
                <div className="space-y-4" data-id="element-276">
                  <div className="flex items-start" data-id="element-277">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-278">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-279" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-280">
                      Everything in Free
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-281">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-282">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-283" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-284">
                      Unlimited reframes
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-285">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-286">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-287" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-288">
                      Advanced analytics
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-289">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-290">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-291" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-292">
                      Personalized insights
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-293">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-294">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-295" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-296">
                      Emotional tracking
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-297">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-298">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-299" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-300">
                      Priority support
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-301">
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-302">
              All premium features are designed to help you manage emotions and
              communicate more effectively. Start with a 7-day free trial, no
              credit card required.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default PricingSection;